import { Box, Skeleton, useTheme } from '@mui/material'

const DocumentListSkeleton = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1,
            borderRadius: 1,
            px: 1,
            py: 1,
            backgroundColor: theme.palette.background.neutral,
          }}
        >
          <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1, flexShrink: 0 }} />
          <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>
            <Skeleton variant="text" width="55%" height={20} />
            <Skeleton variant="text" width="40%" height={16} />
          </Box>
          <Box sx={{ display: 'flex', gap: 0.5, flexShrink: 0 }}>
            <Skeleton variant="circular" width={28} height={28} />
            <Skeleton variant="circular" width={28} height={28} />
            <Skeleton variant="rounded" width={80} height={28} sx={{ borderRadius: 1 }} />
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default DocumentListSkeleton
